import { apiV2 } from 'api'
import { AxiosRequestConfig } from 'axios'

import type {
  ApproveResultV2Params,
  ApproveResultV2Response,
  GetResultsVerificationV2Params,
  GetResultsVerificationV2Response
} from 'services/results/v2/types'

export const approveResultV2 = async (
  resultId: string,
  params: ApproveResultV2Params
): Promise<ApproveResultV2Response> => {
  const { data } = await apiV2.put<ApproveResultV2Response>(`/results/verification/${resultId}/approve`, { ...params })
  return data
}

/**
 * Get the export requests
 * @param params - The parameters for the request
 * @returns The verification status of the result
 */
export const getResultsVerificationV2 = async (
  params: GetResultsVerificationV2Params,
  options?: AxiosRequestConfig
): Promise<GetResultsVerificationV2Response> => {
  const { data } = await apiV2.get<GetResultsVerificationV2Response>('/results/verification', { params, ...options })
  return data
}
